var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOxfordCsNeg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 3280.6934,
    height: 1574.9867,
    viewBox: "0 0 3280.6934 1574.9867",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-273.75471,-214.34811)",
    id: "path5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-735.07912,-214.34811)",
    id: "path7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-850.60165,-190.40023)",
    id: "path9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-568.77461,-237.16018)",
    id: "path11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-978.11605,-279.52648)",
    id: "path13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-354.12131,-147.6215)",
    id: "path15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-202.69671,-354.05833)",
    id: "path17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-275.13751,-348.70963)",
    id: "path19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(0,2.5000001e-5)",
    id: "path21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-371.25341,-348.71773)",
    id: "path23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-413.76401,-348.71773)",
    id: "path25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-510.91031,-348.71773)",
    id: "path27"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(0,2.5000001e-5)",
    id: "path29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-654.09251,-410.08484)",
    id: "path31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-713.53172,-375.65713)",
    id: "path33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-811.6702,-347.42578)",
    id: "path35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-873.29755,-410.08484)",
    id: "path37"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-535.97392,-400.25271)",
    id: "path39"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-849.1381,-878.09572)",
    id: "path41"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-855.8098,-878.09572)",
    id: "path43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-938.83585,-893.19592)",
    id: "path45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-802.39,-927.17323)",
    id: "path47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-840.80935,-960.60112)",
    id: "path49"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-852.43322,-725.34972)",
    id: "path51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-890.84515,-758.77862)",
    id: "path53"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-902.3485,-927.17323)",
    id: "path55"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-940.76462,-960.60112)",
    id: "path57"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-787.70282,-874.59632)",
    id: "path59"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-802.5745,-878.65562)",
    id: "path61"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-831.64622,-885.03162)",
    id: "path63"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-838.54142,-874.61762)",
    id: "path65"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-804.32635,-845.57422)",
    id: "path67"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-812.93012,-845.57422)",
    id: "path69"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-822.51385,-850.10022)",
    id: "path71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-794.87814,-823.62842)",
    id: "path73"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-803.29412,-823.35302)",
    id: "path75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-815.14982,-823.35302)",
    id: "path77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-825.3019,-820.08032)",
    id: "path79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-882.37015,-885.03162)",
    id: "path81"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-889.2703,-874.61762)",
    id: "path83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-905.07775,-871.06852)",
    id: "path85"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-911.26075,-876.65822)",
    id: "path87"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-882.1972,-849.12382)",
    id: "path89"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-893.32502,-849.12382)",
    id: "path91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-900.68552,-853.16282)",
    id: "path93"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-888.47335,-834.03922)",
    id: "path95"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-891.7567,-830.64142)",
    id: "path97"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-906.27272,-825.66892)",
    id: "path99"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-833.27095,-649.29931)",
    id: "path101"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-889.61762,-640.05552)",
    id: "path103"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-857.77022,-1041.6122)",
    id: "path105"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath107"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-989.9992,-989.60102)",
    id: "path107"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-711.33272,-751.08952)",
    id: "path109"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-647.21231,-790.26432)",
    id: "path111"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath113"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-641.50472,-820.65552)",
    id: "path113"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-640.32041,-868.82862)",
    id: "path115"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath117"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-669.59662,-946.95763)",
    id: "path117"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-720.98782,-1016.2827)",
    id: "path119"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-743.17102,-1032.0302)",
    id: "path121"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-808.35025,-1057.9186)",
    id: "path123"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-931.6006,-1002.6981)",
    id: "path125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath127"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1035.3912,-912.71773)",
    id: "path127"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath129"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1023.8397,-873.02952)",
    id: "path129"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1044.8278,-806.23702)",
    id: "path131"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath133"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1011.9123,-938.56912)",
    id: "path133"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-905.9203,-1018.6459)",
    id: "path135"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath137"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-684.26792,-908.18102)",
    id: "path137"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-694.51562,-992.57233)",
    id: "path139"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1036.9635,-760.79232)",
    id: "path141"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath143"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1006.2355,-716.12162)",
    id: "path143"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-988.0837,-669.69442)",
    id: "path145"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath147"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(0,2.5000001e-5)",
    id: "path147"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath149"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1448.6482,-330.44008)",
    id: "path149"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath151"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1484.553,-395.21953)",
    id: "path151"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath153"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1727.5768,-383.04658)",
    id: "path153"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath155"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1805.9775,-398.72631)",
    id: "path155"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath157"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1921.3009,-465.36021)",
    id: "path157"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-2060.1441,-444.11111)",
    id: "path159"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-2219.6161,-387.99778)",
    id: "path161"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath163"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-2273.2569,-402.02714)",
    id: "path163"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath165"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1348.3864,-169.73383)",
    id: "path165"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1555.7218,-146.2142)",
    id: "path167"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(0,2.5000001e-5)",
    id: "path169"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath171"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1709.6265,-203.77191)",
    id: "path171"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath173"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1738.0992,-142.0892)",
    id: "path173"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1977.2043,-146.2142)",
    id: "path175"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath177"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-2076.646,-203.77191)",
    id: "path177"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1364.7126,-522.17052)",
    id: "path179"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath181"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1451.1855,-545.18511)",
    id: "path181"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath183"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1472.6205,-547.51422)",
    id: "path183"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath185"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1537.0099,-541.82971)",
    id: "path185"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath187"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1571.3976,-549.09792)",
    id: "path187"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath189"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1626.1897,-571.64592)",
    id: "path189"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1713.501,-543.32061)",
    id: "path191"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath193"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1768.0164,-545.18511)",
    id: "path193"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath195"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1781.3428,-515.74062)",
    id: "path195"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath197"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1854.5863,-571.64592)",
    id: "path197"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath199"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1913.6671,-546.76881)",
    id: "path199"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath201"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1972.9338,-578.54031)",
    id: "path201"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M 1290.044,1144.862 H 2397.299 V 37.399 H 1290.044 Z M 1271.743,19.202 H 2415.601 V 1163.06 H 1271.743 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1574.9867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M 44.345,18.712 H 1188.203 V 1162.547 H 44.345 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1574.9867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M 49.345,23.712 H 1183.203 V 1157.548 H 49.345 Z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1574.9867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "m 0,0 c 0,39.558 -19.181,67.173 -51.542,67.173 -35.186,0 -51.591,-33.15 -51.591,-67.173 0,-39.549 19.197,-67.132 51.591,-67.132 C -16.372,-67.132 0,-33.981 0,0 m 24.001,0.781 c 0,-43.514 -33.583,-75.101 -75.543,-75.101 -42.782,0 -75.567,31.945 -75.567,73.556 0,43.538 33.583,75.134 75.567,75.134 42.766,0 75.543,-31.995 75.543,-73.589",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,365.00627,1289.1892)",
    clipPath: "url(#clipPath5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m 0,0 c 0,39.558 -19.197,67.173 -51.567,67.173 -35.178,0 -51.558,-33.15 -51.558,-67.173 0,-39.549 19.181,-67.132 51.558,-67.132 C -16.397,-67.132 0,-33.981 0,0 m 23.976,0.781 c 0,-43.514 -33.575,-75.101 -75.543,-75.101 -42.782,0 -75.567,31.945 -75.567,73.556 0,43.538 33.591,75.134 75.567,75.134 42.775,0 75.543,-31.995 75.543,-73.589",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,980.10547,1289.1892)",
    clipPath: "url(#clipPath7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "m 0,0 c -8.402,11.992 -11.601,16.363 -21.981,16.363 h -11.203 v -48.774 c 0,-3.997 1.604,-5.958 6.009,-6.773 l 16.38,-3.598 v -5.219 h -64.357 v 5.219 l 14.793,3.598 c 4.38,1.188 5.984,2.776 5.984,6.773 V 80.337 c 0,3.998 -1.604,5.593 -5.984,6.773 l -14.793,3.598 v 5.228 h 62.753 c 13.205,0 22.388,-1.23 29.984,-3.998 C 33.184,85.93 41.968,71.113 41.968,57.159 41.968,39.541 28.788,24.723 6.79,19.588 V 18.79 c 4.413,-2.036 6.798,-4.82 22.396,-25.239 l 19.58,-25.962 c 2.801,-3.997 6.399,-6.374 10.804,-7.188 l 14.385,-3.183 v -5.219 h -34.38 c -3.998,0 -6.001,1.221 -9.591,6.033 z m -33.184,23.178 h 17.992 c 27.184,0 33.184,17.161 33.184,33.574 0,12.391 -5.601,23.984 -18.391,29.569 -6.79,2.808 -13.189,2.808 -21.989,2.808 h -10.796 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1134.1355,1321.1197)",
    clipPath: "url(#clipPath9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M 0,0 H 6 V -47.984 H 0 l -3.598,14.385 c -1.214,5.219 -4.405,7.197 -9.192,7.197 h -34.796 v -52.763 c 0,-3.998 1.612,-5.959 6,-6.773 l 16.405,-3.607 v -5.211 h -64.365 v 5.211 l 14.793,3.607 c 4.405,1.18 6,2.775 6,6.773 V 33.574 c 0,3.997 -1.595,5.593 -6,6.773 l -14.793,3.607 v 5.219 H 19.181 V 13.155 H 13.18 L 6.399,34.771 c -1.604,5.576 -3.997,7.596 -8.801,7.596 h -45.184 v -61.955 h 34.796 c 4.787,0 7.579,1.97 9.192,7.197 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,758.36613,1258.7731)",
    clipPath: "url(#clipPath11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "m 0,0 v -123.9 c 0,-5.228 1.188,-6.449 6.391,-6.449 h 17.593 c 16.787,0 29.178,2.443 37.979,8.825 14.776,10.77 21.582,30.367 21.582,55.165 0,24.383 -6.806,48.342 -26.784,59.944 C 48.375,-1.604 37.572,0 20.776,0 Z m -41.976,-137.122 v 5.219 l 14.784,3.59 c 4.405,1.188 6,2.784 6,6.789 V -8.792 c 0,3.997 -1.595,5.592 -6,6.781 L -41.976,1.587 V 6.806 H 25.58 c 18.391,0 31.58,-2.41 42.375,-7.197 27.183,-12.399 39.583,-39.175 39.583,-65.56 0,-25.614 -9.607,-49.564 -33.99,-62.362 -11.178,-6.025 -26.776,-8.809 -47.162,-8.809 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1304.1547,1202.2847)",
    clipPath: "url(#clipPath13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M 0,0 V -5.219 H -50.769 V 0 l 12.773,3.175 c 4.829,1.23 8.003,2.792 11.195,6.382 l 43.987,55.181 -43.987,58.373 c -2.784,3.997 -6.366,5.983 -10.779,7.189 l -12,3.191 v 5.218 h 63.159 v -5.218 L 0,130.707 c -4.812,-0.815 -3.607,-2.801 -1.213,-6.009 L 31.164,78.326 h 0.798 l 33.192,46.372 c 2.385,3.208 3.2,4.396 -1.205,5.602 l -12.79,3.191 v 5.218 h 50.769 v -5.218 L 89.138,130.3 c -4.795,-1.206 -7.994,-2.793 -11.202,-6.383 L 36.367,71.511 82.731,10.38 C 85.54,6.374 89.138,4.405 93.526,3.175 L 105.535,0 V -5.219 H 42.367 V 0 l 13.588,2.784 c 4.803,0.806 3.997,2.368 1.595,5.634 L 22.372,57.965 H 21.574 L -13.995,8.751 c -2.402,-3.191 -3.199,-4.346 1.189,-5.576 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,472.16173,1378.158)",
    clipPath: "url(#clipPath15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "m 0,0 c -3.972,-3.973 -9.939,-6.632 -18.258,-6.632 -7.255,0 -13.97,2.286 -18.524,6.84 -6.208,6.199 -5.926,14.127 -5.926,22.587 v 40.032 h 8.161 V 19.829 c 0,-5.443 -0.166,-10.737 4.039,-14.951 2.917,-2.908 7.397,-4.487 12.557,-4.487 5.045,0 9.092,1.745 11.627,4.271 4.679,4.679 4.379,9.773 4.379,22.089 V 62.827 H 6.1 V 28.862 C 6.1,15.965 6.615,6.615 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,270.26227,1102.9089)",
    clipPath: "url(#clipPath17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M 0,0 -32.843,55.888 -32.644,0 h -7.496 v 68.171 h 8.369 L 1.18,11.984 0.981,68.171 H 8.485 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,366.85,1110.0405)",
    clipPath: "url(#clipPath19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "m 312.048,416.879 h 8.202 v -68.171 h -8.202 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1574.9867)",
    clipPath: "url(#clipPath21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "m 0,0 h -9.391 l -23.502,68.171 h 8.543 L -4.463,7.986 16.014,68.171 h 7.937 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,495.00453,1110.0297)",
    clipPath: "url(#clipPath23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M 0,0 V 68.171 H 37.065 V 61.364 H 8.036 V 38.868 H 35.278 V 32.245 H 8.036 V 7.006 h 29.835 l 0,-7.006 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,551.68533,1110.0297)",
    clipPath: "url(#clipPath25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "m 0,0 -7.828,17.668 c -4.862,10.87 -7.064,11.984 -16.946,11.984 h -4.761 V 0 h -8.028 v 68.171 h 14.701 c 9.092,0 15.956,0.058 21.316,-5.311 3.416,-3.407 5.311,-7.945 5.311,-13.629 0,-4.737 -1.372,-8.676 -4.222,-11.709 -2.46,-2.618 -6.515,-4.904 -10.937,-5.377 2.402,-0.141 4.388,-1.438 5.668,-2.718 1.862,-1.861 3.208,-4.67 5.202,-9.125 L 8.535,0 Z m -7.446,57.907 c -3.906,3.915 -8.976,3.731 -14.535,3.731 h -7.554 V 36.184 h 2.709 c 6.889,0 14.302,-0.358 18.973,4.313 2.26,2.26 3.515,5.427 3.515,8.884 0,3.839 -1.496,6.922 -3.108,8.526",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,681.21373,1110.0297)",
    clipPath: "url(#clipPath27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "m 599.084,416.879 h 8.202 v -68.171 h -8.202 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1574.9867)",
    clipPath: "url(#clipPath29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M 0,0 V -61.364 H -8.202 V 0 h -20.253 v 6.798 h 48.658 l 0,-6.798 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,872.12333,1028.2069)",
    clipPath: "url(#clipPath31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M 0,0 V -26.934 H -8.103 V 0 l -21.632,41.228 h 9.374 l 16.804,-31.97 16.305,31.97 h 8.893 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,951.3756,1074.1105)",
    clipPath: "url(#clipPath33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "m 0,0 c -17.651,0 -30.541,14.577 -30.541,35.062 0,21.058 12.757,35.685 31.164,35.685 17.86,0 30.45,-14.469 30.45,-35.054 C 31.073,14.593 18.449,0 0,0 m -0.025,63.783 c -13.363,0 -22.039,-11.278 -22.039,-28.289 0,-16.937 9.657,-28.472 22.471,-28.472 14.253,0 22.173,12.125 22.173,29.02 0,16.621 -9.358,27.741 -22.605,27.741",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1082.2269,1111.7523)",
    clipPath: "url(#clipPath35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "m 0,0 v -22.496 h 26.361 v -6.632 H 0 V -61.364 H -8.136 V 6.798 H 28.065 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1164.3967,1028.2069)",
    clipPath: "url(#clipPath37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "m 0,0 c 0,10.479 8.435,17.934 20.743,17.934 12.466,0 18.441,-6.441 19.048,-7.106 L 35.793,5.992 c -1.521,1.18 -6.981,5.185 -14.51,5.185 -8.701,0 -13.513,-4.545 -13.513,-10.711 0,-2.984 1.222,-5.137 3.192,-6.907 2.335,-2.094 5.75,-3.648 9.415,-5.335 4.571,-2.102 10.837,-4.471 15.034,-8.826 2.9,-3.008 5.103,-6.914 5.103,-12.291 0,-11.335 -7.87,-19.978 -22.015,-19.978 -12.058,0 -19.671,6.64 -20.385,7.313 l 3.756,5.526 c 1.936,-1.437 9.507,-5.916 16.421,-5.916 10.256,0 14.103,5.609 14.103,12.39 0,3.142 -1.437,5.677 -3.565,7.713 -3.175,3.066 -7.986,5.119 -12.599,7.221 -4.579,2.094 -8.992,4.28 -12.116,7.571 C 2.053,-8.892 0,-5.352 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,714.63187,1041.3164)",
    clipPath: "url(#clipPath39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "m 0,0 c 0,8.568 -2.892,15.474 -9.166,19.156 -3.94,2.31 -9.258,3.066 -15.815,3.066 h -47.736 v -96.385 h 51.949 c 11.976,0 19.015,-2.692 19.63,-13.429 h 1.146 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1132.1841,404.1924)",
    clipPath: "url(#clipPath41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "m 0,0 c 0,8.568 2.892,15.474 9.175,19.156 3.931,2.31 9.249,3.066 15.815,3.066 h 48.068 v -96.385 h -52.29 c -11.975,0 -19.014,-2.692 -19.629,-13.429 h -1.147 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1141.0797,404.1924)",
    clipPath: "url(#clipPath43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "m 0,0 v -101.886 h -73.805 l -0.84,-2.086 c -1.288,-3.175 -3.582,-6.125 -11.643,-6.125 -8.044,0 -10.355,2.95 -11.643,6.125 l -0.839,2.086 h -73.681 V 0 h -6.665 v -3.1 l -6.382,1.953 c -0.748,2.527 -3.05,4.371 -5.809,4.371 -3.341,0 -6.067,-2.717 -6.067,-6.075 0,-3.348 2.726,-6.066 6.067,-6.066 1.47,0 2.8,0.54 3.839,1.404 l 8.352,-2.559 v -8.194 l -6.274,1.122 c -0.923,2.169 -3.075,3.689 -5.585,3.689 -3.341,0 -6.058,-2.717 -6.058,-6.074 0,-3.35 2.717,-6.059 6.058,-6.059 1.728,0 3.291,0.723 4.396,1.895 l 7.463,-1.346 v -8.352 l -6.557,0.299 c -1.064,1.753 -2.975,2.959 -5.177,2.959 -3.358,0 -6.084,-2.718 -6.084,-6.076 0,-3.349 2.726,-6.066 6.084,-6.066 2.011,0 3.789,0.997 4.894,2.518 l 6.84,-0.299 v -9.075 l -6.707,-0.241 c -1.097,1.537 -2.883,2.559 -4.928,2.559 -3.34,0 -6.066,-2.726 -6.066,-6.075 0,-3.349 2.726,-6.074 6.066,-6.074 2.194,0 4.106,1.188 5.169,2.933 l 6.466,0.233 v -8.369 l -7.33,-1.255 c -1.113,1.172 -2.667,1.928 -4.404,1.928 -3.358,0 -6.084,-2.726 -6.084,-6.075 0,-3.349 2.726,-6.075 6.084,-6.075 2.476,0 4.612,1.504 5.551,3.648 l 6.183,1.065 v -8.203 l -8.011,-2.452 c -1.056,0.865 -2.377,1.413 -3.848,1.413 -3.341,0 -6.058,-2.725 -6.058,-6.075 0,-3.349 2.717,-6.075 6.058,-6.075 2.751,0 5.061,1.854 5.801,4.371 l 6.058,1.845 v -7.944 l -8.859,-3.815 c -0.947,0.632 -2.094,1.014 -3.332,1.014 -3.341,0 -6.067,-2.726 -6.067,-6.075 0,-3.349 2.726,-6.075 6.067,-6.075 2.991,0 5.46,2.169 5.966,5.011 l 6.225,2.685 v -7.247 h 76.249 c 3.083,-5.41 8.452,-8.203 16.579,-8.203 8.128,0 13.496,2.793 16.596,8.203 H 6.665 L 6.665,0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1251.7811,384.0588)",
    clipPath: "url(#clipPath45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "m 0,0 c -15.408,0 -27.898,-2.402 -27.898,-5.352 0,-2.958 12.49,-5.352 27.898,-5.352 15.408,0 27.907,2.394 27.907,5.352 C 27.907,-2.402 15.408,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1069.8533,338.75573)",
    clipPath: "url(#clipPath47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "m 0,0 -16.114,-11.319 -0.133,-1.155 3.831,-1.712 c 0.756,-0.382 0.765,-0.989 0.374,-1.354 l -10.114,-8.544 -0.964,0.083 -7.172,10.571 c -0.49,0.682 -0.307,1.363 0.557,1.513 l 4.804,0.781 v 1.214 L -37.397,7.696 H -39.45 L -51.916,-9.922 v -1.214 l 4.812,-0.781 c 0.856,-0.15 1.039,-0.831 0.549,-1.513 l -7.172,-10.571 -0.964,-0.083 -9.441,8.544 c -0.391,0.365 -0.382,0.972 0.374,1.354 l 3.831,1.712 -0.141,1.155 L -76.847,0 l -1.363,-0.54 9.856,-30.092 c 5.003,2.252 16.48,3.831 29.935,3.898 13.446,-0.067 24.931,-1.646 29.934,-3.898 L 1.363,-0.54 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1121.0791,294.1852)",
    clipPath: "url(#clipPath49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "m 0,0 c -15.416,0 -27.907,-2.394 -27.907,-5.352 0,-2.958 12.491,-5.352 27.907,-5.352 15.408,0 27.898,2.394 27.898,5.352 C 27.898,-2.394 15.408,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1136.5776,607.85373)",
    clipPath: "url(#clipPath51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "m 0,0 -16.106,-11.319 -0.141,-1.155 3.831,-1.72 c 0.756,-0.374 0.765,-0.981 0.374,-1.347 l -10.105,-8.543 -0.965,0.083 -7.171,10.571 c -0.491,0.682 -0.316,1.363 0.556,1.513 l 4.804,0.781 v 1.205 L -37.389,7.696 H -39.45 L -51.916,-9.931 v -1.205 l 4.812,-0.781 c 0.864,-0.15 1.039,-0.831 0.557,-1.513 l -7.172,-10.571 -0.972,-0.083 -9.441,8.543 c -0.391,0.366 -0.382,0.973 0.374,1.347 l 3.831,1.72 -0.133,1.155 L -76.839,0 l -1.363,-0.532 9.848,-30.1 c 5.003,2.252 16.488,3.822 29.935,3.889 13.454,-0.067 24.931,-1.637 29.934,-3.889 l 9.848,30.1 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1187.7935,563.28187)",
    clipPath: "url(#clipPath53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "m 0,0 c -15.408,0 -27.898,-2.402 -27.898,-5.352 0,-2.958 12.49,-5.352 27.898,-5.352 15.408,0 27.898,2.394 27.898,5.352 C 27.898,-2.402 15.408,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1203.1313,338.75573)",
    clipPath: "url(#clipPath55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "m 0,0 -16.106,-11.319 -0.141,-1.155 3.831,-1.712 c 0.756,-0.382 0.765,-0.989 0.374,-1.354 l -10.105,-8.544 -0.965,0.083 -7.171,10.571 c -0.491,0.682 -0.316,1.363 0.548,1.513 l 4.812,0.781 v 1.214 L -37.389,7.696 h -2.053 L -51.916,-9.922 v -1.214 l 4.82,-0.781 c 0.856,-0.15 1.031,-0.831 0.549,-1.513 l -7.18,-10.571 -0.964,-0.083 -9.433,8.652 c -0.399,0.365 -0.39,0.972 0.366,1.354 l 3.831,1.604 -0.141,1.155 L -76.839,0 l -1.363,-0.54 9.848,-30.092 c 5.003,2.252 16.48,3.831 29.935,3.898 13.454,-0.067 24.931,-1.646 29.934,-3.898 L 1.363,-0.54 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1254.3528,294.1852)",
    clipPath: "url(#clipPath57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "m 0,0 c 0,-1.886 0.474,-2.252 1.488,-2.252 1.828,0 3.681,2.019 3.681,5.776 0,4.57 -2.318,5.842 -4.122,5.842 C 0.549,9.366 0.283,9.308 0.125,9.224 0.025,9.175 0,8.684 0,8.161 Z m 1.047,10.43 c 2.61,0 4.779,-0.508 6.2,-1.887 0.997,-0.955 1.836,-2.526 1.836,-4.363 0,-5.285 -4.022,-7.554 -8.942,-7.554 h -5.476 v 0.823 c 1.562,0.133 1.728,0.282 1.728,2.576 v 7.006 c 0,2.293 -0.166,2.451 -1.554,2.568 v 0.831 z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1050.2704,408.85827)",
    clipPath: "url(#clipPath59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "m 0,0 c 0,-3.848 1.438,-6.657 3.524,-6.657 1.828,0 2.825,1.77 2.825,5.618 C 6.349,3.224 4.82,5.585 3,5.585 1.363,5.585 0,3.723 0,0 m 10.313,-0.358 c 0,-4.553 -3.108,-7.395 -7.188,-7.395 -4.297,0 -7.073,3.124 -7.073,7.03 0,3.441 2.294,7.413 7.372,7.413 3.889,0 6.889,-2.851 6.889,-7.048",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1070.0993,403.44587)",
    clipPath: "url(#clipPath61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "M 0,0 V -0.831 C -1.621,-0.98 -1.704,-1.064 -1.637,-3.299 l 0.208,-7.114 c 0.058,-2.352 0.099,-2.418 1.628,-2.568 v -0.831 h -6.648 v 0.831 c 1.604,0.15 1.662,0.216 1.637,2.568 l -0.058,7.479 h -0.091 l -4.097,-10.654 h -1.139 l -3.898,9.907 h -0.041 l -0.15,-4.721 c -0.066,-1.82 -0.041,-2.834 0.042,-3.491 0.083,-0.797 0.557,-0.988 1.936,-1.088 v -0.831 h -5.252 v 0.831 c 1.022,0.083 1.421,0.291 1.554,1.088 0.108,0.657 0.241,1.779 0.341,3.707 l 0.232,4.297 c 0.142,2.676 -0.025,2.909 -1.703,3.058 V 0 h 5.003 L -8.419,-8.419 -5.169,0 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1108.8616,394.94453)",
    clipPath: "url(#clipPath63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "m 0,0 c 0,-2.294 0.166,-2.443 1.629,-2.576 v -0.823 h -6.873 v 0.823 c 1.463,0.133 1.629,0.282 1.629,2.576 v 7.014 c 0,2.294 -0.166,2.443 -1.629,2.568 v 0.831 H 1.629 V 9.582 C 0.166,9.457 0,9.308 0,7.014 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1118.0552,408.82987)",
    clipPath: "url(#clipPath65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "M 0,0 H -1.82 L -9.69,10.03 H -9.732 V 6.117 c 0,-2.228 0.084,-3.399 0.175,-4.056 0.108,-0.74 0.681,-1.022 2.078,-1.089 V 0.15 h -5.286 v 0.822 c 0.931,0.05 1.488,0.349 1.596,1.089 0.083,0.657 0.166,1.828 0.166,4.056 v 3.913 c 0,1.571 -0.042,1.854 -0.474,2.444 -0.316,0.449 -0.839,0.59 -1.604,0.657 v 0.83 h 4.687 l 7.073,-8.817 h 0.05 v 2.85 c 0,2.228 -0.092,3.399 -0.167,4.056 -0.116,0.74 -0.689,1.014 -2.086,1.081 v 0.83 h 5.41 v -0.83 C 0.831,13.089 0.274,12.79 0.175,12.05 0.091,11.393 0,10.222 0,7.994 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1072.4351,447.5544)",
    clipPath: "url(#clipPath67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "m 0,0 c -1.463,3.823 -3.457,9.075 -4.23,11.069 -0.69,1.829 -1.122,1.937 -2.144,2.062 v 0.83 h 6.873 v -0.83 l -0.732,-0.084 c -0.781,-0.091 -0.781,-0.282 -0.548,-1.022 0.382,-1.188 2.061,-5.377 2.85,-7.454 0.657,1.803 2.011,5.859 2.344,6.864 0.457,1.296 0.332,1.521 -0.632,1.629 l -0.64,0.067 v 0.83 h 5.145 v -0.83 C 7.081,12.981 6.781,12.873 5.95,10.945 5.826,10.646 3.233,4.338 1.637,0 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1083.9068,447.5544)",
    clipPath: "url(#clipPath69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "m 0,0 c 0.449,-1.23 1.704,-3.59 3.781,-3.59 1.106,0 1.953,0.723 1.953,2.102 0,1.255 -0.822,1.954 -2.119,2.552 L 3.299,1.213 c -1.745,0.806 -3.723,1.903 -3.723,4.189 0,2.402 1.745,4.346 5.078,4.346 0.656,0 1.338,-0.075 1.961,-0.249 C 7.097,9.366 7.438,9.291 7.712,9.2 7.804,8.369 7.953,7.33 8.186,5.884 L 7.247,5.734 C 6.781,7.139 6.042,8.651 4.355,8.651 3.274,8.651 2.501,7.82 2.501,6.798 2.501,5.734 3.333,5.12 4.695,4.504 L 5.161,4.288 C 7.122,3.399 8.792,2.31 8.792,-0.166 c 0,-2.618 -2.094,-4.529 -5.393,-4.529 -0.848,0 -1.72,0.166 -2.294,0.357 -0.631,0.216 -1.08,0.382 -1.338,0.515 -0.166,0.972 -0.44,2.119 -0.706,3.54 z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1096.6851,441.51973)",
    clipPath: "url(#clipPath71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "m 0,0 c 0,-2.294 0.166,-2.443 1.629,-2.576 v -0.823 h -6.873 v 0.823 c 1.463,0.133 1.629,0.282 1.629,2.576 v 7.014 c 0,2.294 -0.166,2.443 -1.629,2.568 v 0.831 H 1.629 V 9.582 C 0.166,9.457 0,9.308 0,7.014 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1059.8375,476.81547)",
    clipPath: "url(#clipPath73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "m 0,0 c 0,-1.105 0.042,-1.629 0.416,-1.82 0.34,-0.183 0.831,-0.199 1.495,-0.199 0.674,0 1.596,0.058 2.037,0.623 0.34,0.399 0.698,0.972 1.047,2.103 L 5.9,0.548 C 5.776,-0.258 5.335,-2.468 5.136,-3.116 H -5.402 v 0.822 c 1.612,0.125 1.787,0.275 1.787,2.568 v 7.014 c 0,2.294 -0.175,2.444 -1.596,2.568 v 0.831 H 1.704 V 9.856 C 0.166,9.732 0,9.582 0,7.288 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1071.0588,477.18267)",
    clipPath: "url(#clipPath75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "m 0,0 c 0,-1.105 0.042,-1.629 0.424,-1.82 0.341,-0.183 0.823,-0.199 1.479,-0.199 0.682,0 1.604,0.058 2.045,0.623 0.34,0.399 0.698,0.972 1.047,2.103 L 5.9,0.548 C 5.776,-0.258 5.335,-2.468 5.144,-3.116 H -5.402 v 0.822 c 1.612,0.125 1.787,0.275 1.787,2.568 v 7.014 c 0,2.294 -0.175,2.444 -1.596,2.568 v 0.831 H 1.695 V 9.856 C 0.166,9.732 0,9.582 0,7.288 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1086.8664,477.18267)",
    clipPath: "url(#clipPath77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "m 0,0 c -1.463,3.823 -3.466,9.075 -4.23,11.069 -0.706,1.829 -1.122,1.929 -2.144,2.062 v 0.83 H 0.49 v -0.83 l -0.723,-0.084 c -0.789,-0.091 -0.789,-0.282 -0.557,-1.022 0.391,-1.188 2.061,-5.377 2.851,-7.454 0.648,1.803 2.019,5.859 2.352,6.864 0.449,1.288 0.324,1.521 -0.632,1.629 l -0.64,0.067 v 0.83 h 5.145 v -0.83 C 7.072,12.981 6.773,12.873 5.95,10.945 5.826,10.646 3.233,4.338 1.637,0 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1100.4025,481.54627)",
    clipPath: "url(#clipPath79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M 0,0 V -0.831 C -1.612,-0.98 -1.704,-1.064 -1.637,-3.299 l 0.216,-7.114 c 0.05,-2.352 0.091,-2.418 1.629,-2.568 v -0.831 h -6.649 v 0.831 c 1.596,0.15 1.654,0.216 1.629,2.568 l -0.05,7.479 h -0.099 l -4.097,-10.654 h -1.139 l -3.889,9.907 h -0.05 l -0.141,-4.721 c -0.075,-1.82 -0.05,-2.834 0.033,-3.491 0.083,-0.797 0.557,-0.988 1.936,-1.088 v -0.831 h -5.244 v 0.831 c 1.014,0.083 1.421,0.291 1.546,1.088 0.108,0.657 0.241,1.779 0.341,3.707 l 0.232,4.297 c 0.15,2.676 -0.016,2.909 -1.695,3.058 V 0 h 4.995 L -8.419,-8.419 -5.169,0 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1176.4935,394.94453)",
    clipPath: "url(#clipPath81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "m 0,0 c 0,-2.294 0.166,-2.443 1.629,-2.576 v -0.823 h -6.873 v 0.823 c 1.463,0.133 1.629,0.282 1.629,2.576 v 7.014 c 0,2.294 -0.166,2.443 -1.629,2.568 v 0.831 H 1.629 V 9.582 C 0.166,9.457 0,9.308 0,7.014 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1185.6937,408.82987)",
    clipPath: "url(#clipPath83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    d: "M 0,0 H -1.828 L -9.69,10.03 H -9.732 V 6.117 c 0,-2.228 0.084,-3.399 0.175,-4.056 0.1,-0.74 0.665,-1.022 2.078,-1.089 V 0.15 h -5.286 v 0.822 c 0.931,0.05 1.488,0.349 1.587,1.089 0.092,0.657 0.167,1.828 0.167,4.056 v 3.913 c 0,1.571 -0.034,1.854 -0.458,2.444 -0.324,0.449 -0.856,0.59 -1.612,0.657 v 0.83 h 4.687 l 7.073,-8.817 h 0.049 v 2.85 c 0,2.228 -0.091,3.399 -0.174,4.056 -0.108,0.74 -0.682,1.014 -2.078,1.081 v 0.83 h 5.41 v -0.83 C 0.831,13.089 0.274,12.79 0.166,12.05 0.091,11.393 0,10.222 0,7.994 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1206.7703,413.562)",
    clipPath: "url(#clipPath85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "M 0,0 H 2.718 L 1.38,4.055 H 1.321 Z m 2.693,-4.612 0.64,0.083 c 0.789,0.108 0.839,0.324 0.556,1.088 l -0.773,2.169 h -3.473 l -0.64,-2.044 c -0.274,-0.914 -0.274,-1.122 0.698,-1.23 l 0.615,-0.066 v -0.832 h -4.945 v 0.832 c 1.08,0.149 1.396,0.233 2.103,2.019 L 1.729,8.394 3.183,8.684 4.621,4.671 C 5.543,2.144 6.457,-0.358 7.263,-2.526 7.945,-4.379 8.327,-4.479 9.374,-4.612 V -5.444 H 2.693 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1215.0143,406.10907)",
    clipPath: "url(#clipPath87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "m 0,0 c 0,-2.294 0.174,-2.443 1.961,-2.576 v -0.823 h -7.438 v 0.823 c 1.704,0.133 1.87,0.282 1.87,2.576 V 9.308 H -3.972 C -5.394,9.308 -5.967,9.05 -6.316,8.659 -6.557,8.352 -6.815,7.804 -7.097,6.607 h -0.889 c 0.091,1.787 0.207,3.249 0.257,4.329 h 0.657 c 0.324,-0.482 0.532,-0.523 1.105,-0.523 h 8.468 c 0.566,0 0.665,0.125 1.006,0.523 H 4.172 C 4.18,10.047 4.297,8.236 4.396,6.673 L 3.466,6.607 C 3.141,7.878 2.909,8.435 2.601,8.801 2.235,9.175 1.529,9.308 0.515,9.308 H 0 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1176.2629,442.8216)",
    clipPath: "url(#clipPath89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "m 0,0 c 0,-2.294 0.166,-2.443 1.637,-2.576 v -0.823 h -6.881 v 0.823 c 1.463,0.133 1.629,0.282 1.629,2.576 v 7.006 c 0,2.302 -0.166,2.451 -1.629,2.576 v 0.831 H 1.637 V 9.582 C 0.166,9.457 0,9.308 0,7.006 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1191.1,442.8216)",
    clipPath: "url(#clipPath91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "m 0,0 c 0,-3.848 1.438,-6.657 3.524,-6.657 1.828,0 2.825,1.77 2.825,5.618 0,4.263 -1.529,6.624 -3.357,6.624 C 1.363,5.585 0,3.723 0,0 m 10.305,-0.366 c 0,-4.545 -3.108,-7.388 -7.18,-7.388 -4.297,0 -7.081,3.125 -7.081,7.023 0,3.449 2.294,7.421 7.372,7.421 3.897,0 6.889,-2.851 6.889,-7.056",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1200.914,437.43627)",
    clipPath: "url(#clipPath93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "m 0,0 v -0.831 c -1.612,-0.141 -1.695,-0.233 -1.637,-2.468 l 0.216,-7.114 c 0.058,-2.352 0.1,-2.418 1.629,-2.568 v -0.823 h -6.649 v 0.823 c 1.596,0.15 1.654,0.216 1.637,2.568 l -0.058,7.488 h -0.099 l -4.097,-10.654 h -1.139 l -3.889,9.898 h -0.05 l -0.141,-4.713 c -0.067,-1.828 -0.042,-2.842 0.033,-3.498 0.091,-0.798 0.557,-0.989 1.936,-1.089 v -0.823 h -5.244 v 0.823 c 1.022,0.083 1.421,0.291 1.554,1.089 0.1,0.656 0.233,1.778 0.333,3.714 l 0.232,4.289 c 0.15,2.676 -0.016,2.917 -1.695,3.058 V 0 h 4.995 L -8.419,-8.418 -5.169,0 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1184.6311,462.9344)",
    clipPath: "url(#clipPath95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "M 0,0 C 0,2.294 -0.166,2.443 -1.587,2.568 V 3.399 H 8.477 C 8.493,3.033 8.61,1.488 8.709,-0.108 L 7.787,-0.166 C 7.571,0.872 7.338,1.463 6.989,1.803 6.657,2.169 5.95,2.294 4.82,2.294 H 4.463 c -0.806,0 -0.848,0 -0.848,-0.74 V -2.551 H 4.67 c 1.837,0 1.895,0.124 2.111,1.745 h 0.931 v -5.02 H 6.781 C 6.565,-3.956 6.507,-3.823 4.67,-3.823 H 3.615 v -3.465 c 0,-1.106 0.042,-1.629 0.424,-1.82 0.341,-0.183 0.831,-0.2 1.487,-0.2 0.848,0 1.787,0.133 2.261,0.64 0.357,0.382 0.706,1.164 1.039,2.186 l 0.922,-0.15 C 9.648,-7.67 9.208,-9.84 9.017,-10.405 h -10.82 v 0.823 C -0.166,-9.457 0,-9.308 0,-7.014 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1189.0089,467.4648)",
    clipPath: "url(#clipPath97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "M 0,0 H 2.717 L 1.38,4.055 H 1.313 Z m 2.693,-4.612 0.64,0.083 c 0.789,0.108 0.839,0.324 0.556,1.089 l -0.773,2.168 h -3.473 l -0.64,-2.044 c -0.274,-0.914 -0.274,-1.122 0.69,-1.238 l 0.623,-0.058 v -0.832 h -4.945 v 0.832 c 1.08,0.149 1.396,0.233 2.103,2.019 L 1.729,8.394 3.183,8.684 4.621,4.671 C 5.543,2.144 6.457,-0.358 7.263,-2.526 7.945,-4.379 8.327,-4.479 9.374,-4.612 V -5.444 H 2.693 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1208.3636,474.0948)",
    clipPath: "url(#clipPath99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "m 0,0 c 0,-3.075 -2.485,-5.56 -5.56,-5.56 -3.066,0 -5.551,2.485 -5.551,5.56 0,3.075 2.485,5.552 5.551,5.552 C -2.485,5.552 0,3.075 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1111.0279,709.25427)",
    clipPath: "url(#clipPath101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "m 0,0 c 0,-3.075 -2.485,-5.56 -5.56,-5.56 -3.066,0 -5.551,2.485 -5.551,5.56 0,3.067 2.485,5.552 5.551,5.552 C -2.485,5.552 0,3.067 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1186.1568,721.57933)",
    clipPath: "url(#clipPath103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "m 0,0 c 0,-3.075 -2.485,-5.552 -5.56,-5.552 -3.066,0 -5.551,2.477 -5.551,5.552 0,3.075 2.485,5.56 5.551,5.56 C -2.485,5.56 0,3.075 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1143.6936,186.1704)",
    clipPath: "url(#clipPath105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "m 0,0 c -0.133,-3.067 -2.717,-5.452 -5.792,-5.31 -3.067,0.116 -5.444,2.717 -5.311,5.784 0.125,3.058 2.718,5.435 5.776,5.31 C -2.252,5.66 0.125,3.067 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1319.9989,255.51867)",
    clipPath: "url(#clipPath107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "m 0,0 c 2.128,-3.075 3.208,-6.358 3.2,-9.757 -0.009,-3.889 -1.305,-7.047 -8.244,-11.85 l -20.07,-14.294 -3.69,5.31 c 0,0 20.552,14.635 20.884,14.867 3.54,2.452 5.053,4.247 5.061,7.048 0,1.778 -0.648,3.715 -1.936,5.568 -2.003,2.9 -4.579,3.823 -6.865,3.831 -2.052,0 -4.28,-1.454 -8.227,-4.213 l -18.873,-12.79 -3.615,5.211 17.95,12.166 c 4.995,3.507 8.976,5.909 12.674,5.909 C -6.357,6.989 -2.427,3.49 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,948.4436,573.534)",
    clipPath: "url(#clipPath109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "M 0,0 38.178,13.38 40.289,7.596 18.449,-19.081 46.04,-8.161 48.093,-13.795 10.371,-28.289 8.252,-22.505 30.209,4.205 2.053,-5.643 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,862.94973,521.30093)",
    clipPath: "url(#clipPath111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M 0,0 39.957,5.925 40.896,-0.474 0.947,-6.399 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,855.3396,480.77933)",
    clipPath: "url(#clipPath113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "m 0,0 0.15,6.707 39.873,-16.206 -0.274,-6.656 -40.946,-12.2 0.034,6.706 33.2,9.308 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,853.76053,416.54853)",
    clipPath: "url(#clipPath115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "m 0,0 c 2.368,4.305 4.055,5.934 6.557,5.925 0.931,0 2.102,-0.232 3.274,-0.881 1.521,-0.839 2.676,-2.227 3.108,-3.731 0.167,-0.582 0.241,-1.163 0.225,-1.745 -0.009,-2.402 -1.347,-4.82 -2.751,-7.338 L 9.582,-9.266 -1.795,-3.15 Z M 7.18,12.241 C 1.479,12.233 -1.172,8.959 -4.812,2.377 l -4.737,-8.494 35.577,-19.313 3.075,5.56 -14.792,8.069 0.872,1.596 c 2.477,4.504 3.341,5.177 9.69,4.645 l 11.527,-1.014 3.291,5.967 -13.272,1.13 c -2.676,0.241 -4.778,0.441 -6.482,-0.049 -0.565,-0.158 -1.255,-0.516 -1.912,-0.981 0.15,0.723 0.424,1.43 0.433,2.161 0.008,1.138 -0.15,2.268 -0.499,3.29 -0.773,2.369 -2.46,4.297 -5.02,5.71 -1.911,1.047 -3.822,1.596 -5.759,1.587",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,892.79547,312.37653)",
    clipPath: "url(#clipPath117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "m 0,0 5.144,3.922 24.508,-32.103 -5.136,-3.922 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,961.31707,219.94307)",
    clipPath: "url(#clipPath119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M 0,0 26.128,13.596 28.671,8.693 18.507,3.407 34.605,-27.524 28.871,-30.508 12.765,0.415 2.543,-4.903 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,990.89467,198.9464)",
    clipPath: "url(#clipPath121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "m 0,0 6.815,1.903 -5.485,-27.026 4.438,-15.341 -6.159,-1.778 -4.338,15.225 -19.172,20.02 6.632,1.919 13.804,-14.377 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1077.8003,164.42853)",
    clipPath: "url(#clipPath123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M 0,0 20.51,34.796 39.807,23.436 37.007,18.665 23.228,26.793 17.552,17.161 30.524,9.524 27.782,4.862 14.809,12.507 5.526,-3.258 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1242.1341,238.05587)",
    clipPath: "url(#clipPath125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    d: "m 0,0 14.701,17.601 2.302,-6.972 -10.961,-12.524 16.272,-3.657 2.16,-6.565 -22.255,5.386 -15.807,-18.949 -2.252,6.857 11.926,13.903 -17.835,4.072 -2.169,6.624 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1380.5215,358.02973)",
    clipPath: "url(#clipPath127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "m 0,0 40.273,3.283 1.811,-22.33 -5.51,-0.449 -1.296,15.947 -11.136,-0.914 1.213,-15.008 -5.376,-0.433 -1.231,15.001 -18.224,-1.488 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1365.1195,410.94733)",
    clipPath: "url(#clipPath129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "m 0,0 c -7.862,0 -17.053,4.288 -17.053,12.225 0,2.858 0.989,6.723 4.546,9.307 2.393,1.737 5.518,2.668 9.008,2.668 4.006,0 11.228,-1.13 15.017,-6.349 1.305,-1.803 1.978,-3.898 1.97,-6.133 0,-3.092 -1.263,-6.765 -4.587,-9.167 C 6.557,0.848 3.474,0 0,0 m -3.183,30.782 c -4.662,0 -8.959,-1.263 -12.341,-3.723 -6.108,-4.421 -7.213,-10.762 -7.213,-14.477 0,-13.654 12.831,-19.114 22.463,-19.114 4.637,-0.008 8.867,1.255 12.208,3.665 6.798,4.928 7.18,12.341 7.18,14.726 0,11.909 -10.961,18.923 -22.297,18.923",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1393.1037,500.004)",
    clipPath: "url(#clipPath131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "m 0,0 c -3.623,0 -6.906,1.521 -9.158,5.078 -1.155,1.82 -1.712,3.781 -1.712,5.75 -0.025,4.571 2.867,9.258 8.161,12.624 3.507,2.228 6.947,3.316 10.03,3.307 3.898,0 7.064,-1.712 9.184,-5.044 1.246,-1.97 1.811,-4.063 1.811,-6.158 0,-4.462 -2.817,-8.826 -7.936,-12.075 C 6.781,1.205 3.175,0 0,0 m 6.291,32.91 c -4.08,0 -8.435,-1.297 -12.624,-3.956 -7.762,-4.92 -10.587,-11.976 -10.587,-17.12 0,-3.332 0.922,-6.598 2.817,-9.599 4.313,-6.806 10.779,-8.468 15.142,-8.443 4.172,0.017 8.568,1.396 12.715,4.03 4.994,3.167 10.554,9.059 10.554,17.029 0,3.307 -0.939,6.565 -2.85,9.59 -3.541,5.568 -9.075,8.469 -15.167,8.469",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1349.2164,323.5612)",
    clipPath: "url(#clipPath133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    d: "m 0,0 c -2.917,0 -7.147,1.429 -9.507,5.742 -1.139,2.087 -1.654,4.629 -1.654,7.247 0,7.239 4.828,17.377 13.621,17.377 4.936,0 11.144,-3.681 11.144,-12.806 C 13.604,11.734 9.516,0 0,0 m 2.078,36.026 c -8.411,0 -15.74,-5.668 -18.699,-15.74 -0.656,-2.228 -1.072,-4.454 -1.072,-6.599 0,-4.03 0.673,-7.221 2.327,-10.246 3.74,-6.832 10.571,-9.158 15.782,-9.158 2.925,0 5.759,0.673 8.352,2.085 6.814,3.732 11.31,12.375 11.31,20.652 0,3.598 -0.698,6.981 -2.285,9.873 -3.283,5.958 -9.349,9.133 -15.715,9.133",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1207.8937,216.79213)",
    clipPath: "url(#clipPath135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "m 0,0 5.427,-1.537 -6.125,-22.181 -39.084,10.72 6.673,22.439 5.31,-1.496 -4.903,-16.181 10.771,-2.958 4.163,14.701 5.203,-1.479 -4.147,-14.651 12.191,-3.342 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,912.3572,364.07867)",
    clipPath: "url(#clipPath137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    d: "m 0,0 c 5.618,6.291 11.352,5.859 11.352,5.859 l 0.981,-5.327 c 0,0 -4.421,-0.15 -7.887,-4.031 -1.512,-1.687 -2.269,-3.449 -2.269,-5.044 0,-1.305 0.507,-2.452 1.538,-3.366 2.8,-2.493 7.571,0.274 10.571,1.479 2.302,0.948 5.568,2.277 8.842,2.277 2.443,0 4.961,-0.69 7.263,-2.75 2.685,-2.402 4.039,-5.419 4.039,-8.577 0,-3.432 -1.329,-6.49 -4.014,-9.49 -5.152,-5.768 -12.083,-6.399 -12.083,-6.399 l -1.371,5.401 c 4.08,0.948 7.172,2.519 9.042,4.621 1.479,1.654 2.202,3.499 2.202,5.119 0,1.521 -0.64,2.951 -1.887,4.064 -1.005,0.898 -2.235,1.222 -3.573,1.197 -2.601,0 -5.709,-1.488 -8.269,-2.551 -4.912,-2.037 -10.081,-3.665 -14.718,0.473 -2.36,2.111 -3.615,4.754 -3.615,7.696 0,3.108 1.23,6.415 3.856,9.349",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,926.0208,251.55693)",
    clipPath: "url(#clipPath139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "m 0,0 c -1.828,0 -4.92,1.047 -6.083,4.055 -0.291,0.765 -0.416,1.538 -0.416,2.327 0.025,2.211 1.072,4.505 2.144,6.923 l 0.69,1.562 L 7.986,9.632 6.698,6.515 C 4.521,1.579 3.108,0.008 0,0 m -23.851,23.951 15.266,-6.906 -0.748,-1.721 c -2.086,-4.703 -2.875,-5.459 -9.249,-5.493 l -11.56,-0.008 -2.759,-6.233 13.33,0.042 c 2.701,0 4.803,0 6.44,0.631 0.532,0.208 1.147,0.54 1.704,0.989 -0.025,-0.341 -0.158,-0.673 -0.158,-1.022 -0.016,-1.479 0.266,-2.95 0.814,-4.238 1.837,-4.272 6.807,-6.358 10.455,-6.35 6.416,0.009 8.876,3.856 12.001,10.929 0.124,0.257 3.756,8.651 3.756,8.651 l -36.733,16.546 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1382.618,560.59693)",
    clipPath: "url(#clipPath141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    d: "m 0,0 c -3.208,0 -6.224,1.238 -9.358,3.74 -3.183,2.543 -6.548,6.498 -6.548,11.551 0,3.499 1.903,6.848 4.836,10.513 L -8.402,29.161 14.66,10.754 12.914,8.543 C 8.626,3.166 5.701,0 0,0 m -14.394,30.416 c -4.188,-5.252 -7.363,-9.939 -7.363,-15.997 0,-5.136 2.335,-10.987 8.236,-15.699 3.914,-3.133 8.344,-4.82 12.914,-4.82 5.618,0 10.131,1.687 17.12,10.455 l 6.382,8.019 -31.563,25.206 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1341.6473,620.15787)",
    clipPath: "url(#clipPath143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "m 0,0 c -37.588,-13.305 -72.684,-12.382 -102.618,-5.693 0.989,13.355 6.516,27.649 14.967,30.308 65.927,20.444 113.945,81.9 113.945,154.35 0,89.097 -72.633,161.581 -161.888,161.581 -89.271,0 -161.897,-72.484 -161.897,-161.581 0,-49.571 23.162,-96.658 62.13,-127.182 -9.258,-4.072 -17.153,-10.646 -22.863,-18.84 -2.958,2.019 -5.8,4.105 -8.435,6.266 l -1.471,-1.471 c 1.754,-2.128 4.496,-4.945 7.779,-8.086 -4.795,-8.078 -7.571,-17.477 -7.571,-27.525 0,-1.57 0.1,-3.099 0.233,-4.637 -57.999,42.267 -92.463,109.465 -92.463,181.475 0,123.809 100.74,224.541 224.558,224.541 123.818,0 224.549,-100.732 224.549,-224.541 C 88.955,108.036 56.536,42.89 0,0 m -130.267,-52.996 c -31.031,0 -69.75,10.538 -96.36,26.237 -8.061,4.762 -17.677,13.604 -17.677,28.729 0,4.072 0.807,7.969 2.219,11.559 9.931,-8.219 20.195,-15.914 26.635,-19.43 1.48,-0.822 2.336,-1.213 4.064,-1.213 4.122,0 7.48,3.366 7.48,7.505 0,3.174 -1.712,5.751 -4.563,6.989 -5.501,2.41 -17.028,7.171 -29.427,13.595 5.742,7.571 14.768,12.483 24.948,12.483 4.654,0 9.133,-0.997 13.313,-2.967 l 8.502,-4.953 c 27.042,-16.513 96.601,-58.871 180.587,-35.602 -31.871,-28.762 -71.138,-42.932 -119.721,-42.932 m 26.585,-18.906 c -8.526,0 -15.524,-6.042 -15.524,-15.316 0,-9.059 7.089,-15.292 15.524,-15.292 1.288,0 2.518,0.208 3.698,0.524 -1.786,-12.84 -16.729,-27.192 -36.001,-33.641 -19.114,6.391 -34.064,20.86 -36.034,33.625 1.172,-0.3 2.394,-0.508 3.673,-0.508 9.208,0 15.524,6.441 15.524,15.292 0,8.46 -6.631,15.092 -15.191,15.283 2.609,4.77 5.119,9.839 6.964,15.291 10.613,-1.845 21.059,-2.85 30.782,-2.85 7.953,0 15.69,0.424 23.253,1.188 0.997,-4.371 2.493,-8.951 4.238,-13.679 -0.299,0.017 -0.598,0.083 -0.906,0.083 M -213.438,49.912 c 15.964,0 30.898,-8.185 39.657,-21.307 -7.67,1.944 -15.2,4.47 -22.554,7.612 l -0.017,-0.041 -0.241,0.124 c -5.136,2.427 -10.637,3.657 -16.355,3.657 -12.715,0 -23.967,-6.241 -30.923,-15.774 -2.926,1.613 -5.851,3.325 -8.718,5.103 8.61,12.441 22.937,20.626 39.151,20.626 m 63.193,-31.854 c -1.978,-1.462 -3.557,-3.224 -4.687,-5.152 -5.859,2.826 -13.214,6.499 -18.026,9.191 6.815,-1.503 15.715,-3.415 22.713,-4.039 m 49.14,3.042 c -4.646,-6.631 -7.413,-15.856 -8.228,-25.189 -14.685,3.782 -27.998,8.868 -39.608,14.161 2.203,4.272 8.527,7.305 13.347,7.305 11.842,0 23.361,1.313 34.489,3.723 m -34.489,2.768 c -9.914,0 -19.687,0.955 -29.253,2.783 -9.233,18.109 -28.148,29.752 -48.591,29.752 -5.02,0 -9.865,-0.731 -14.486,-2.003 -39.292,29.186 -62.719,75.625 -62.719,124.565 0,85.515 69.551,155.082 155.049,155.082 85.49,0 155.049,-69.567 155.049,-155.082 0,-85.522 -69.559,-155.097 -155.049,-155.097 m -77.844,-69.517 c -26.278,0 -47.636,21.432 -47.636,47.776 0,8.261 2.086,16.023 5.784,22.804 2.443,-2.219 5.069,-4.537 7.795,-6.864 -2.318,-4.903 -3.648,-10.346 -3.648,-16.097 0,-14.336 7.23,-26.178 20.901,-34.248 7.853,-4.628 16.745,-8.809 26.161,-12.449 -3.058,-0.607 -6.191,-0.922 -9.357,-0.922 M 95.795,178.965 c 0,127.391 -103.798,231.039 -231.389,231.039 -127.591,0 -231.397,-103.648 -231.397,-231.039 0,-76.431 37.729,-147.659 100.964,-190.832 6.224,-23.153 27.408,-40.273 52.589,-40.273 6.806,0 13.413,1.28 19.687,3.707 8.469,-2.801 17.211,-5.111 25.929,-6.898 -2.443,-7.022 -6.042,-13.679 -9.457,-19.429 0,0 0.074,0.016 0.191,0.041 -0.058,-0.041 -0.133,-0.075 -0.2,-0.117 l 4.829,-4.82 c 1.221,0.665 2.618,1.089 4.113,1.089 4.762,0 8.635,-3.881 8.635,-8.651 0,-4.745 -3.873,-8.626 -8.635,-8.626 -4.163,0 -7.811,2.659 -9.723,5.51 0,0 -1.122,-3.881 -1.122,-9.009 -0.033,-16.596 18.092,-35.552 43.206,-43.547 25.106,7.812 43.215,26.91 43.207,43.522 0,5.718 -1.122,9.034 -1.122,9.034 -1.928,-2.319 -5.061,-5.51 -9.782,-5.51 -4.762,0 -8.634,3.881 -8.634,8.626 0,4.77 3.872,8.651 8.634,8.651 1.671,0 3.216,-0.507 4.538,-1.321 l 4.679,4.67 c 0.116,-0.016 0.174,-0.042 0.174,-0.042 -2.643,6.325 -4.571,12.142 -5.892,17.727 41.611,5.609 76.722,23.211 104.629,52.555 l -0.025,0.034 c 58.074,44.119 91.374,111.06 91.374,183.909",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1317.4449,682.0608)",
    clipPath: "url(#clipPath145)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "M 2410.601,24.201 H 1276.743 v 1133.858 h 1133.858 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1574.9867)",
    clipPath: "url(#clipPath147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "m 0,0 c -5.981,-3.093 -19.185,-6.187 -35.895,-6.187 -44.148,0 -70.968,27.644 -70.968,69.934 0,45.799 31.771,73.444 74.269,73.444 16.71,0 28.675,-3.507 33.832,-6.19 l -5.569,-20.217 c -6.602,2.887 -15.68,5.364 -27.232,5.364 -28.263,0 -48.686,-17.743 -48.686,-51.163 0,-30.533 17.948,-50.129 48.479,-50.129 10.315,0 21.043,2.062 27.645,5.157 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1931.5309,1134.3999)",
    clipPath: "url(#clipPath149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "m 0,0 c 0,-28.263 14.233,-50.75 38.577,-50.75 24.55,0 38.371,22.693 38.371,51.78 0,26.2 -12.995,50.956 -38.371,50.956 C 13.409,51.986 0,28.675 0,0 m 103.769,2.063 c 0,-46.624 -28.265,-73.236 -66.636,-73.236 -39.196,0 -63.953,29.913 -63.953,70.761 0,42.702 26.82,72.823 66.015,72.823 40.642,0 64.574,-30.739 64.574,-70.348",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1979.4039,1048.0273)",
    clipPath: "url(#clipPath151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "M 0,0 C -0.824,17.948 -1.856,39.609 -1.65,58.384 H -2.269 C -6.808,41.468 -12.585,22.693 -18.772,5.159 l -20.219,-60.24 H -58.59 L -77.156,4.333 c -5.364,17.742 -10.315,36.721 -14.028,54.051 h -0.414 C -92.216,40.23 -93.04,18.154 -94.073,-0.824 l -3.094,-55.907 h -23.724 l 9.282,139.045 h 33.422 l 18.155,-55.908 c 4.951,-16.298 9.282,-32.802 12.789,-48.273 h 0.62 c 3.713,15.059 8.458,32.183 13.821,48.479 l 19.187,55.702 H 19.393 L 27.438,-56.731 H 2.683 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2303.4357,1064.2579)",
    clipPath: "url(#clipPath153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    d: "m 0,0 c 3.095,-0.826 7.222,-1.032 12.379,-1.032 18.979,0 30.531,9.284 30.531,25.582 0,15.472 -10.726,23.723 -28.262,23.723 C 7.634,48.273 2.683,47.655 0,47.035 Z m -25.168,64.777 c 9.076,1.651 21.661,2.889 38.783,2.889 18.569,0 32.184,-3.921 41.054,-11.347 8.252,-6.807 13.615,-17.742 13.615,-30.739 0,-13.203 -4.125,-24.136 -11.965,-31.563 -10.108,-10.109 -25.992,-14.854 -43.94,-14.854 -4.745,0 -9.078,0.206 -12.379,0.826 v -52.4 h -25.168 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2407.9699,1043.3516)",
    clipPath: "url(#clipPath155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "m 0,0 v -81.075 c 0,-27.231 11.347,-39.816 28.469,-39.816 18.36,0 29.295,12.585 29.295,39.816 V 0 h 25.374 v -79.425 c 0,-42.91 -22.073,-61.889 -55.493,-61.889 -32.184,0 -53.019,17.949 -53.019,61.683 l 0,79.631 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2561.7345,954.5064)",
    clipPath: "url(#clipPath157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "M 0,0 H -39.609 V 21.249 H 65.397 V 0 H 25.374 V -117.796 H 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2746.8587,982.83853)",
    clipPath: "url(#clipPath159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M 0,0 H -52.4 V -40.846 H 6.189 V -61.683 H -77.774 V 77.362 H 3.095 V 56.527 H -52.4 V 20.631 H 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2959.488,1057.6563)",
    clipPath: "url(#clipPath161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    d: "m 0,0 h 15.06 c 17.124,0 27.85,9.076 27.85,22.899 0,15.266 -10.726,22.28 -27.23,22.28 C 7.634,45.179 2.477,44.561 0,43.94 Z m -25.168,61.477 c 9.49,1.65 23.724,2.888 38.371,2.888 20.011,0 33.626,-3.3 42.91,-11.14 C 63.747,46.829 68.078,37.133 68.078,25.374 68.078,7.426 55.907,-4.745 42.91,-9.49 v -0.618 c 9.903,-3.713 15.886,-13.41 19.393,-26.819 4.331,-17.33 8.046,-33.422 10.932,-38.785 H 47.037 c -2.064,4.125 -5.365,15.472 -9.284,32.802 -3.919,18.154 -10.521,23.929 -24.962,24.344 H 0 v -57.146 h -25.168 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,3031.0091,1038.9505)",
    clipPath: "url(#clipPath163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "m 0,0 c 8.254,-4.745 20.631,-8.872 33.628,-8.872 16.298,0 25.374,7.634 25.374,18.98 0,10.521 -7.014,16.71 -24.756,23.106 -22.899,8.252 -37.547,20.423 -37.547,40.434 0,22.693 18.981,40.023 49.1,40.023 15.06,0 26.2,-3.301 33.42,-7.016 L 73.031,86.233 c -4.951,2.682 -14.647,6.601 -27.644,6.601 -16.092,0 -23.106,-8.664 -23.106,-16.71 0,-10.728 8.046,-15.68 26.613,-22.899 24.137,-9.076 35.896,-21.249 35.896,-41.26 0,-22.281 -16.916,-41.672 -52.812,-41.672 -14.648,0 -29.914,4.125 -37.547,8.664 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1797.8485,1348.6749)",
    clipPath: "url(#clipPath165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    d: "m 0,0 c -5.981,-3.093 -19.185,-6.187 -35.897,-6.187 -44.146,0 -70.964,27.644 -70.964,69.934 0,45.799 31.769,73.444 74.265,73.444 16.712,0 28.677,-3.507 33.834,-6.19 l -5.569,-20.217 c -6.602,2.887 -15.68,5.364 -27.233,5.364 -28.262,0 -48.685,-17.743 -48.685,-51.163 0,-30.533 17.946,-50.129 48.479,-50.129 10.315,0 21.043,2.062 27.645,5.157 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2074.2957,1380.0344)",
    clipPath: "url(#clipPath167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "m 1602.761,142.089 h -25.374 v 139.045 h 25.374 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1574.9867)",
    clipPath: "url(#clipPath169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    d: "M 0,0 H -52.401 V -40.846 H 6.189 V -61.683 H -77.775 V 77.362 H 3.095 V 56.527 H -52.401 V 20.631 l 52.401,0 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2279.502,1303.2908)",
    clipPath: "url(#clipPath171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M 0,0 V 139.045 H 28.881 L 64.777,79.425 C 74.062,63.953 82.108,47.861 88.501,32.802 h 0.414 c -1.65,18.566 -2.27,36.514 -2.27,57.764 v 48.479 h 23.519 V 0 h -26.2 L 47.655,61.065 C 38.783,76.33 29.501,93.454 22.693,109.132 l -0.62,-0.206 C 23.105,90.978 23.312,72.617 23.312,49.718 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2317.4656,1385.5344)",
    clipPath: "url(#clipPath173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "m 0,0 c -5.981,-3.093 -19.185,-6.187 -35.897,-6.187 -44.146,0 -70.964,27.644 -70.964,69.934 0,45.799 31.769,73.444 74.265,73.444 16.712,0 28.677,-3.507 33.834,-6.19 l -5.569,-20.217 c -6.602,2.887 -15.68,5.364 -27.232,5.364 -28.263,0 -48.686,-17.743 -48.686,-51.163 0,-30.533 17.946,-50.129 48.479,-50.129 10.315,0 21.043,2.062 27.645,5.157 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2636.2723,1380.0344)",
    clipPath: "url(#clipPath175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M 0,0 H -52.401 V -40.846 H 6.189 V -61.683 H -77.775 V 77.362 H 3.095 V 56.527 H -52.401 V 20.631 l 52.401,0 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2768.8613,1303.2908)",
    clipPath: "url(#clipPath177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    d: "m 0,0 c 2.05,-0.374 5.032,-0.467 8.199,-0.467 17.333,0 26.742,9.691 26.742,26.649 C 35.034,40.997 26.649,50.407 9.504,50.407 5.313,50.407 2.143,50.035 0,49.568 Z m -8.104,55.532 c 4.937,0.745 10.807,1.305 17.237,1.305 11.645,0 19.938,-2.703 25.436,-7.828 5.59,-5.123 8.852,-12.391 8.852,-22.548 0,-10.25 -3.169,-18.635 -9.04,-24.413 -5.868,-5.868 -15.558,-9.037 -27.765,-9.037 -5.776,0 -10.622,0.28 -14.72,0.745 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1819.6167,878.75933)",
    clipPath: "url(#clipPath179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    d: "M 0,0 H -24.412 V -22.643 H 2.796 v -6.801 H -32.517 V 33.355 H 1.398 v -6.801 h -25.81 V 6.707 L 0,6.707 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1934.9139,848.0732)",
    clipPath: "url(#clipPath181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    d: "m 0,0 c 1.772,-0.467 4.008,-0.653 6.709,-0.653 9.783,0 15.746,4.752 15.746,13.418 0,8.292 -5.868,12.298 -14.813,12.298 C 4.101,25.063 1.398,24.784 0,24.41 Z m -8.104,30.281 c 3.912,0.652 9.037,1.212 15.558,1.212 8.014,0 13.884,-1.865 17.611,-5.218 3.448,-2.982 5.497,-7.547 5.497,-13.139 0,-5.682 -1.677,-10.154 -4.845,-13.417 C 21.431,-4.846 14.443,-7.175 6.523,-7.175 4.101,-7.175 1.865,-7.082 0,-6.616 v -25.158 h -8.104 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1963.4939,844.96773)",
    clipPath: "url(#clipPath183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    d: "m 0,0 -6.151,18.076 c -1.396,4.1 -2.329,7.827 -3.26,11.461 h -0.186 c -0.932,-3.727 -1.958,-7.549 -3.168,-11.369 L -18.916,0 Z m -20.593,-6.337 -6.522,-19.752 h -8.386 l 21.338,62.8 h 9.783 l 21.431,-62.8 H 8.385 L 1.677,-6.337 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2049.3465,852.54707)",
    clipPath: "url(#clipPath185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    d: "m 0,0 h 8.294 c 8.664,0 14.161,4.751 14.161,11.927 0,8.106 -5.868,11.645 -14.441,11.738 -3.913,0 -6.709,-0.372 -8.014,-0.743 z m -8.104,28.604 c 4.098,0.838 9.969,1.305 15.558,1.305 8.666,0 14.258,-1.584 18.171,-5.125 3.167,-2.796 4.937,-7.082 4.937,-11.926 0,-8.293 -5.218,-13.789 -11.832,-16.027 v -0.279 c 4.844,-1.677 7.733,-6.149 9.224,-12.672 2.05,-8.759 3.541,-14.815 4.844,-17.237 h -8.386 c -1.024,1.769 -2.422,7.175 -4.191,15.001 C 18.356,-9.69 15.001,-6.43 7.642,-6.151 H 0 v -27.206 h -8.104 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2095.1967,842.85613)",
    clipPath: "url(#clipPath187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188",
    d: "M 0,0 H -19.1 V 6.894 H 27.394 V 0 H 8.201 V -55.905 H 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2168.2529,812.79213)",
    clipPath: "url(#clipPath189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path190",
    d: "M 0,0 C -0.467,8.759 -1.026,19.288 -0.933,27.113 H -1.212 C -3.355,19.754 -5.963,11.926 -9.133,3.26 L -20.221,-27.208 H -26.37 L -36.527,2.703 c -2.981,8.85 -5.496,16.956 -7.266,24.41 h -0.188 c -0.186,-7.825 -0.65,-18.354 -1.21,-27.766 l -1.676,-26.927 h -7.735 l 4.379,62.8 H -39.88 L -29.166,4.846 c 2.61,-7.735 4.754,-14.629 6.337,-21.152 h 0.279 c 1.584,6.337 3.82,13.231 6.616,21.152 L -4.753,35.22 H 5.59 l 3.912,-62.8 H 1.584 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2284.6679,850.5592)",
    clipPath: "url(#clipPath191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path192",
    d: "M 0,0 H -24.412 V -22.643 H 2.796 v -6.801 H -32.517 V 33.355 H 1.398 v -6.801 h -25.81 V 6.707 L 0,6.707 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2357.3552,848.0732)",
    clipPath: "url(#clipPath193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    d: "M 0,0 V 62.8 H 8.852 L 28.978,31.028 c 4.66,-7.361 8.292,-13.977 11.274,-20.406 l 0.188,0.092 c -0.746,8.388 -0.932,16.028 -0.932,25.811 V 62.8 h 7.64 V 0 H 38.949 L 19.009,31.867 C 14.629,38.854 10.436,46.029 7.268,52.831 L 6.989,52.738 C 7.454,44.817 7.642,37.27 7.642,26.835 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2375.1237,887.33253)",
    clipPath: "url(#clipPath195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    d: "M 0,0 H -19.1 V 6.894 H 27.394 V 0 H 8.201 V -55.905 H 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2472.7817,812.79213)",
    clipPath: "url(#clipPath197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    d: "m 0,0 c 0,-13.417 7.268,-25.437 20.033,-25.437 12.858,0 20.126,11.832 20.126,26.087 0,12.486 -6.523,25.532 -20.033,25.532 C 6.709,26.182 0,13.789 0,0 m 48.73,1.024 c 0,-21.617 -13.136,-33.076 -29.164,-33.076 -16.584,0 -28.23,12.857 -28.23,31.864 0,19.94 12.391,32.986 29.164,32.986 17.144,0 28.23,-13.139 28.23,-31.774",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2551.5561,845.9616)",
    clipPath: "url(#clipPath199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    d: "M 0,0 H 33.822 V -6.802 H 8.104 v -20.871 h 23.761 v -6.708 H 8.104 V -62.8 H 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2630.5784,803.5996)",
    clipPath: "url(#clipPath201)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxfordCsNeg);
export default __webpack_public_path__ + "static/media/oxford-cs-neg.d0a7c665db41f086ea980cbca09c60be.svg";
export { ForwardRef as ReactComponent };